import { Outlet } from 'react-router-dom';
// hooks
import useOffSetTop from '../../hooks/useOffSetTop';
// components
import Header from './Header';
import { useLayout } from 'src/contexts/LayoutContext';

// ----------------------------------------------------------------------

export default function RegistrationLayout() {
  const { headerLayout } = useLayout();
  const isOffset = useOffSetTop(headerLayout.H_MAIN_DESKTOP);

  return (
    <>
      <Header isOffset={isOffset} />

      <Outlet />
    </>
  );
}
